import {
    AlertTypes,
    GenericFormContainer,
    IAlertData,
    Leap4Breadcrumbs,
    Mode,
    Spinner,
    apiClient,
    MuiIcons
} from "@leap4/frontend";
import {AddOrganizationStore} from "./addOrganizationStore";
import {useHistory, useParams} from "react-router-dom";
import {useEffect, useMemo, useState} from "react";
import {OrganizationsBaseUrl} from "../../../../config/generals";
import {connect, ConnectedProps, useDispatch} from "react-redux";
import {urlService} from "../../../routing/urlsService";
import {IOrganizationAdvertiserLogin} from "../../interfaces/IOrganizationAdvertiserLogin";
import { OrganizationContext, IClientCredentials } from "../OrganizationContex";
import {DetailsForm} from "../DetailsForm";
import {initialOrganizationObj} from "../Organization"
import {setAlert} from "../../../../actions/alert";
import {createNewOrganization} from "../../../../actions/users";

const {Toc: CreateIcon} = MuiIcons;

export interface IEditGroupProps extends PropsFromRedux {
    setGroup: (data: IAlertData) => void;
}

const mapStateToProps = () => ({});

const mapActions = {
    setAlert
}

const connector = connect(mapStateToProps, mapActions);
type PropsFromRedux = ConnectedProps<typeof connector>;


let editOrganizationStore: AddOrganizationStore


const _editOrganization = (props: IEditGroupProps) => {
    const setAlert = props.setAlert
    const params = useParams<{ id?: string }>();
    const history = useHistory();
    const dispatch = useDispatch();
    const [organization, setOrganization] = useState<IOrganizationAdvertiserLogin>(initialOrganizationObj);
    const [clientCredentials, setClientCredentials] = useState<IClientCredentials | null>(null);
    const organizationsContextValue = useMemo(
        () => ({organization, setOrganization, clientCredentials, setClientCredentials, savedPartnersByOrg: {}}),
        [organization, clientCredentials]
    );
    const [isLoading, setIsLoading] = useState(false)
    const [isLoadError, setIsLoadError] = useState(false)

    const onSubmit = async () => {
        if (organization.name.length < 3) {
            setAlert("Name not valid - minimum 3 letters", AlertTypes.FAILURE);
            return;
        }
        try {
            setIsLoading(true)
            await createNewOrganization(dispatch, organization.name)
        } catch(err) {
            setAlert(err.toString(), AlertTypes.FAILURE)
        } finally {
            setIsLoading(false)
        }
        setAlert("Organization " + organization.name + " created successfully", AlertTypes.SUCCESS)
        history.push(urlService.organizations());
    };


    useEffect(() => {
        if (!params.id) {
            return;
        }
        editOrganizationStore = new AddOrganizationStore({
                setIsLoading,
                setIsLoadError,
                setItem: (x) => {setOrganization(x)},
                axiosClient: apiClient,
                alertFunc: props.setGroup,
                baseUrl: `${OrganizationsBaseUrl}`
            }
        )
        editOrganizationStore.refreshItem(params.id)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.id])

    if (isLoadError) {
        return (<>Error Loading the page</>);
    }
    if (isLoading) {
        return (<Spinner/>);
    }

    return (
        <>
            <Leap4Breadcrumbs breadcrumbs={[{
                text: "Create ",
                link: urlService.organizations(),
                icon: <CreateIcon/>
                },
                {
                    text: organization.name,
                    link: urlService.organizations(),
                    icon: <CreateIcon/>
                },
            ]}
            />
            <GenericFormContainer mode={Mode.Create} onCreateOrEditFunc={onSubmit} buttonsProps={{delete: {"disabled":true}}}>
                <OrganizationContext.Provider value={organizationsContextValue}>
                    <DetailsForm />
                </OrganizationContext.Provider>
            </GenericFormContainer>
        </>
    )
}

export const addOrganization = connect(mapStateToProps, {
    setAlert
})(_editOrganization);
